import {
	CREATE_BRAND_PROJECT_FORM_MODULE_ID,
	CREATE_PROJECT_FORM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

import createProject from 'root/src/client/logic/project/thunks/createProject'
import createProjectSkipPledge from 'root/src/client/logic/project/thunks/createProjectSkipPledge'
import createProjectProduct from 'root/src/client/logic/project/thunks/createProjectProduct'
import { createProjectFormStepKeys } from 'root/src/shared/descriptions/modules/createProjectForm'

export default {
	[CREATE_PROJECT_FORM_MODULE_ID]: [
		{
			action: createProject,
		},
		{
			action: createProjectSkipPledge,
		},
		{
			stepId: createProjectFormStepKeys.productDares,
			action: createProjectProduct,
		},
	],
	[CREATE_BRAND_PROJECT_FORM_MODULE_ID]: [
		{
			action: createProjectProduct,
		},
	],
}
